export function getToolTipDom(props) {
  console.log('props tooltip ', props);
  let toolT = '<div class="toolWrap">';
  toolT += '<div class="toolImageWrap">';
  toolT += `<img src="${props.thumbPath}" width="110" height="110" alt="${props.location}" />`;
  toolT += '</div>';
  toolT += '<div class="toolTextWrap">';
  toolT += `<div class="toolLocation">${props.location}</div>`;
  toolT += `<div class="toolType">${props.type}</div>`;
  toolT += '<div class="readMore">Read more below</div>';
  toolT += '</div>';

  toolT += '</div>';
  return toolT;
}
